import { SelectionState } from '../reducers/selection';
import { Action } from 'redux';

export const enum ActionType {
  SET_SELECTION_STATE = 'SET_SELECTION_STATE',
}

export interface SetSelectionStateAction extends Action {
  type: ActionType.SET_SELECTION_STATE;
  selectionState: SelectionState;
}

export type SelectionAction = SetSelectionStateAction;

export function setSelectionState(selectionState: SelectionState): SetSelectionStateAction {
  return { selectionState, type: ActionType.SET_SELECTION_STATE };
}

export function isSelectionAction(action: Action): action is SelectionAction {
  switch (action.type) {
    case ActionType.SET_SELECTION_STATE:
      return true;
    default:
      return false;
  }
}
